import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ENDPOINTS from "../../config/apiUrls";
import { getRequest, postRequest } from "../../config/dataApi";
import { getOffset, getToken } from "../../helpers/utils";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInstance";
import qs from 'qs';


export const getStationsList = createAsyncThunk(
  "invites/getStationsList",
  async (_, { rejectWithValue, getState }) => {
    try {
      
      const response = await getRequest(`${ENDPOINTS.INVITES.STATIONS_DATA}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.errors?.[0]?.detail || "Something went wrong."
      );
    }
  }
);

export const getInvitesList = createAsyncThunk(
  "invites/getInvitesList",
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const meta = state.invites.meta || {};
      const term = state.invites.searchTerm;
      const limit = meta.perPage || meta.limit || 10;
      const page = meta.page || 1;

      const offset = page === 1 ? 0 : (page - 1) * limit;

      const params = {
        criteria: 'created',
        limit,
        order: "DESC",
        offset,
      };

      if (term && term.trim() !== '') {
        params.filter = JSON.stringify({ id: term.trim() });
      }
      const queryParams = new URLSearchParams(params).toString();

      const response = await getRequest(`${ENDPOINTS.INVITES.LIST}?${queryParams}`);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.errors?.[0]?.detail || "Something went wrong."
      );
    }
  }
);

export const updateStationGroupAdmin = createAsyncThunk(
  'invites/updateStationGroupAdmin',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.UPDATE_STATION_GROUP_ADMIN, { data: payload });

      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const togglePodcast = createAsyncThunk(
  'invites/togglePodcast',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_PODCAST, { data: payload });

      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const toggleAudioAds = createAsyncThunk(
  'invites/toggleAudioAds',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_AUDIO_ADS, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const sendNewInvite = createAsyncThunk(
  'invites/sendNewInvite',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.NEW_INVITE, { data: payload });
      if (response.status === 202) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const sendNewInviteWithoutEmail = createAsyncThunk(
  'invites/sendNewInviteWithoutEmail',
  async ({ payload }, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.NEW_INVITE_WITHOUT_EMAIL, { data: payload });
        return response.data.data.secret;
      
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(
        error.response?.data?.errors?.[0]?.detail ||
        error.response?.data?.errors?.[0]?.title ||
        error.message ||
        'An error occurred.'
      );
    }
  }
);

export const registerStationAdmin = createAsyncThunk(
  'invites/registerStationAdmin',
  async ({ payload }, { rejectWithValue, getState, dispatch }) => {
    try {
      await axiosInstance.post(ENDPOINTS.INVITES.REGISTER_STATION_ADMIN, payload );
      dispatch(getInvitesList());
        return true;
      
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(
        error.response?.data?.errors?.[0]?.detail ||
        error.response?.data?.errors?.[0]?.title ||
        error.message ||
        'An error occurred.'
      );
    }
  }
);

export const DeleteInviteRequest = createAsyncThunk(
  'invites/DeleteInviteRequest',
  async ({ message = 'updated successfully', id, silent = false }, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await axiosInstance.delete(ENDPOINTS.INVITES.DELETE_INVITE_REQUEST + '/' + id);
      if (response.status === 200) {
        if (!silent) {
          toast.success(message, {
            position: "top-right",
            autoClose: 3000,
          });
        }

        return id;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const ResendInviteRequest = createAsyncThunk(
  'invites/ResendInviteRequest',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await axiosInstance.delete(ENDPOINTS.INVITES.RESEND_INVITE_REQUEST ,{data : payload});
      if (response.status === 200) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);



export const toggleAdsWizsAds = createAsyncThunk(
  'invites/toggleAdsWizsAds',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_ADS_WIZ, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const toggleVideoAdsAds = createAsyncThunk(
  'invites/toggleVideoAdsAds',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_VIDEO_ADS, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const toggleClassicAds = createAsyncThunk(
  'invites/toggleClassicAds',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_CLASSIC_ADS, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const updateNotificationsToggle = createAsyncThunk(
  'invites/updateNotificationsToggle',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.TOGGLE_NOTIFICATIONS, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const ModifyAlias = createAsyncThunk(
  'invites/ModifyAlias',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.INVITES.MODIFY_ALIAS_DATA, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);

export const ModifyStationGroup = createAsyncThunk(
  'invites/ModifyStationGroup',
  async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
    try {
      const response = await axiosInstance.put(ENDPOINTS.INVITES.UPDATE_METADATA, { data: payload });
      if (response.status === 204) {
        toast.success(message, {
          position: "top-right",
          autoClose: 3000,
        });

        return payload;
      } else {
        return rejectWithValue('Failed to update profile.');
      }
    } catch (error) {
      console.log(error.message);
      return rejectWithValue(error.response?.data?.errors[0].detail || 'An error occurred.');
    }
  }
);


export const getUserData = createAsyncThunk("invites/getUserData", async (id, { rejectWithValue, getState }) => {
  try {

    const { data } = await axiosInstance.get(ENDPOINTS.INVITES.GET_METADATA, {
      params: { id },
      paramsSerializer: params => qs.stringify(params, { indices: false }),
    });
    return data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.errors[0].detail || "Something went wrong.");
  }
});

export const addTeamMember = createAsyncThunk("invites/addTeamMember", async ({ message = 'updated successfully', payload }, { rejectWithValue, getState }) => {
  try {

    const response = await axiosInstance.post(ENDPOINTS.INVITES.REGISTER_MEMBER, { data: payload });
    if (response.status === 200) {
      toast.success(message, {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      return rejectWithValue('Failed to update profile.');
    }
  } catch (error) {
    console.log(error)
    return rejectWithValue(error.response?.data?.errors[0].detail || "Something went wrong.");
  }
});

const invitesSlice = createSlice({
  name: "invites",
  initialState: {
    users: [],
    stationsList:[],
    meta: {
      page: 1,
      pages: 1,
      totalRecords: 10,
      perPage: 10,
    },
    searchTerm: '',
    loading: false,
    error: null,
  },
  reducers: {
    changePerPage: (state, action) => {
      state.meta.perPage = action.payload;
    },
    changePage: (state, action) => {
      state.meta.page = action.payload;
    },
    searchInvite: (state, action) => {
      state.searchTerm = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvitesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInvitesList.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        const metaData = action.payload.meta;

        state.meta = {
          page: metaData.page,
          pages: metaData.pages,
          totalRecords: metaData.pages * metaData.cursor,
          perPage: state.meta.perPage
        };
      })
      .addCase(getInvitesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getStationsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.stationsList = action.payload.data;

      })
      .addCase(getStationsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(togglePodcast.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enablePodcast } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enablePodcast: enablePodcast
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(toggleAdsWizsAds.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enableDisableAdsWizz } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enableDisableAdsWizz: enableDisableAdsWizz
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(toggleAudioAds.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enableAudioAds } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enableAudioAds: enableAudioAds
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(toggleVideoAdsAds.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enableVideoAds } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enableVideoAds: enableVideoAds
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(toggleClassicAds.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enableAds } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enableAds: enableAds
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(updateNotificationsToggle.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { enableNotification, firebaseProject } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    enableNotification: enableNotification,
                    firebaseProject
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(ModifyAlias.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { priority, hidden,alias } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata,
                  ["3"]: {
                    ...user.attributes.metadata["3"],
                    priority: priority,
                    hidden,
                    ...(alias !== undefined && { alias })
                  }
                }
              }
            };
          }
          return user;
        });
      })
      .addCase(ModifyStationGroup.fulfilled, (state, action) => {
        state.loading = false;

        const { id, attributes: { stationGroup } } = action.payload;
        state.users = state.users.map((user) => {
          if (user.attributes.id == id) {
            return {
              ...user,
              attributes: {
                ...user.attributes,
                metadata: {
                  ...user.attributes.metadata, stationGroup
                }
              }
            };
          }
          return user;
        });
      })

  },
});
export const { changePerPage, changePage, searchInvite } = invitesSlice.actions;
export default invitesSlice.reducer;
